import api from './api';

export default {
    async login(payload) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
            };
            const response = await api.post(`/auth/login`, payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao fazer login:', error);
                throw error;
        }
    },
    async refreshToken(token) {
        const payload = {
            refreshToken: token
        };
        try {
            const headers = {};
            const response = await api.post('/auth/renew-refresh', payload, {headers});
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar token:', error);
            throw error;
        }
    },  

    async logout(token) {
        try {
            const headers = {
                'Authorization': `Bearer ${token}`
            };
            const response = await api.post('/auth/logout', {}, {headers});
            return response.data;
        } catch (error) {
            console.error('Erro ao fazer logout:', error);
            throw error;
        }
    },

    async forgotPassword(payload) {
        try {
            const headers = {
                'Content-Type': 'application/json',
            };
            const response = await api.post('/users/forgot_password', payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao solicitar recuperação de senha:', error);
            throw error;
        }
    },

    async resetPassword(payload) {
        try {
            const headers = {
                'Content-Type': 'application/json',
            };
            const response = await api.put('/users/reset_password', payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao redefinir senha:', error);
            throw error;
        }
    },
    async changePassword(payload) {
        try {
            const headers = {
                'Content-Type': 'application/json',
            };
            const response = await api.put('/users/change_password', payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao alterar senha:', error);
            throw error;
        }
    }
}   
